module.exports = __webpack_public_path__ + "static/media/MD.5de47074.png";